/**
 * CreditDisplay Component
 * Displays current credit balance for authenticated users
 * Updates automatically when credits change
 */

import { useState } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useCreditsContext } from '../../contexts/CreditsContext';
import { CreditPurchaseModal } from './CreditPurchaseModal';

/**
 * CreditDisplay component
 * Shows the user's current credit balance with option to purchase more
 * Only visible when user is authenticated
 * Automatically updates when credits change
 * 
 * @returns Credit display component or null if not authenticated
 */
export function CreditDisplay() {
  const { isAuthenticated, isLoading: authLoading } = useAuthContext();
  const { credits, isLoading: creditsLoading } = useCreditsContext();
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);

  // Only show when authenticated
  if (!isAuthenticated || authLoading) {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}
      >
        <span 
          aria-live="polite" 
          aria-atomic="true"
          style={{
            color: 'var(--color-fg)',
            fontSize: 'var(--font-size-xs)'
          }}
        >
          AI Credits: {creditsLoading ? '...' : credits}
        </span>
        <button
          onClick={() => setIsPurchaseModalOpen(true)}
          style={{
            background: 'var(--color-accent)',
            color: 'var(--color-bg)',
            border: 'none',
            borderRadius: '4px',
            padding: '0.25rem 0.5rem',
            fontSize: 'var(--font-size-xs)',
            cursor: 'pointer',
            fontFamily: 'var(--font-family)',
            transition: 'opacity 0.2s',
            fontWeight: 'bold'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          aria-label="Add more credits"
        >
          + Add
        </button>
      </div>
      
      <CreditPurchaseModal 
        isOpen={isPurchaseModalOpen}
        onClose={() => setIsPurchaseModalOpen(false)}
      />
    </>
  );
}
